import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './Imprint.css';

function Imprint() {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('imprint');

  // Set active section based on URL state
  useEffect(() => {
    if (location.state && location.state.activeSection) {
      setActiveSection(location.state.activeSection);
    }
  }, [location.state]);

  return (
    <div className="imprint-page">
      <div className="imprint-nav">
        <Link to="/" className="imprint-nav__logo">
          <img src={process.env.PUBLIC_URL + '/img/sparkle.svg'} alt="Northstar Logo" className="imprint-nav__logo-img" />
          <span className="imprint-nav__logo-text">NORTH STAR</span>
        </Link>
        <Link to="/" className="imprint-nav__back-btn">
          Back to Home
        </Link>
      </div>
      
      <div className="imprint-container">
        <div className="imprint-header">
          <h1>Legal Information</h1>
        </div>

        <div className="imprint-tabs">
          <button 
            className={`imprint-tab ${activeSection === 'imprint' ? 'active' : ''}`}
            onClick={() => setActiveSection('imprint')}
          >
            Imprint
          </button>
          <button 
            className={`imprint-tab ${activeSection === 'terms' ? 'active' : ''}`}
            onClick={() => setActiveSection('terms')}
          >
            Terms of Use
          </button>
          <button 
            className={`imprint-tab ${activeSection === 'privacy' ? 'active' : ''}`}
            onClick={() => setActiveSection('privacy')}
          >
            Privacy Policy
          </button>
        </div>

        <div className="imprint-content">
          {activeSection === 'imprint' && (
            <div className="imprint-section">
              <h2>Imprint</h2>
              
              <div className="imprint-info">
                <h3>Information according to § 5 TMG</h3>
                <p>
                  North Star Digital Marketing Ltd<br />
                  Unit 14, Hackney Downs Studios<br />
                  17 Amhurst Terrace<br />
                  London E8 2BT<br />
                  United Kingdom
                </p>
                
                <h3>Contact</h3>
                <p>
                  Email: info@northstarpromo.com<br />
                  Phone: +44 20 1234 5678
                </p>
              
              </div>
            </div>
          )}
          
          {activeSection === 'terms' && (
            <div className="imprint-section">
              <h2>Terms of Use</h2>
              
              <div className="imprint-info">
                <h3>1. Scope and Acceptance</h3>
                <p>
                  These Terms of Use govern your use of the Northstar Promotion website and services. By accessing or using our website, you agree to be bound by these Terms. If you do not agree with any part of these terms, you may not use our website or services.
                </p>
                
                <h3>2. Intellectual Property</h3>
                <p>
                  All content on this website, including but not limited to text, graphics, logos, images, audio clips, digital downloads, and data compilations, is the property of Northstar Promotion or its content suppliers and is protected by international copyright laws.
                </p>
                
                <h3>3. User Conduct</h3>
                <p>
                  You agree to use our website only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the website. Prohibited behavior includes harassing or causing distress to other users, transmitting obscene or offensive content, or disrupting the normal flow of dialogue within our website.
                </p>
                
                <h3>4. User Accounts</h3>
                <p>
                  Some sections of our website may require registration. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
                </p>
                
                <h3>5. Limitation of Liability</h3>
                <p>
                  North Star Promotion shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages resulting from your access to or use of, or inability to access or use, the website or any content thereon.
                </p>
                
                <h3>6. Modifications</h3>
                <p>
                  We reserve the right to modify these Terms of Use at any time. Your continued use of the website after any such changes constitutes your acceptance of the new Terms of Use.
                </p>
                
                <h3>7. Governing Law</h3>
                <p>
                  These Terms of Use shall be governed by and construed in accordance with the laws of the United Kingdom, without regard to its conflict of law provisions.
                </p>
              </div>
            </div>
          )}
          
          {activeSection === 'privacy' && (
            <div className="imprint-section">
              <h2>Privacy Policy</h2>
              
              <div className="imprint-info">
                <h3>1. Introduction</h3>
                <p>
                  At North Star Promotion, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website. Please read this policy carefully. By continuing to use our website, you consent to the practices described in this policy.
                </p>
                
                <h3>2. Information We Collect</h3>
                <p>
                  <strong>Personal Data:</strong> We may collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and services, when you participate in activities on our website, or otherwise when you contact us.
                </p>
                <p>
                  <strong>Automatically Collected Information:</strong> We automatically collect certain information when you visit our website, including your IP address, browser type, operating system, access times, and the pages you have viewed on our site. We may also collect information about actions you take on our website, such as links clicked.
                </p>
                
                <h3>3. How We Use Your Information</h3>
                <p>
                  We may use the information we collect for various purposes, including to:
                </p>
                <ul>
                  <li>Provide, operate, and maintain our website</li>
                  <li>Improve, personalize, and expand our website</li>
                  <li>Understand and analyze how you use our website</li>
                  <li>Develop new products, services, features, and functionality</li>
                  <li>Communicate with you, either directly or through one of our partners</li>
                  <li>Send you emails</li>
                  <li>Find and prevent fraud</li>
                </ul>
                
                <h3>4. Cookies</h3>
                <p>
                  We use cookies and similar tracking technologies to track activity on our website and hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
                </p>
                
                <h3>5. Third-Party Services</h3>
                <p>
                  We may use third-party service providers to monitor and analyze the use of our website or to host our newsletter subscription services.
                </p>
                
                <h3>6. Data Security</h3>
                <p>
                  We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure.
                </p>
                
                <h3>7. Your Rights</h3>
                <p>
                  If you are a resident of the European Economic Area (EEA), you have certain data protection rights. We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.
                </p>
                
                <h3>8. Changes to This Privacy Policy</h3>
                <p>
                  We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
                </p>
                
                <h3>9. Contact Us</h3>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at info@northstarpromo.com.
                </p>
                
                <p className="last-updated">Last Updated: June 2023</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Imprint; 